export default [
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Year",
        labelName: "label",
        reduce: "id",
        options: [],
        model: null,
        cols: 6,
    },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Month",
        labelName: "label",
        options: [],
        reduce: "id",
        model: null,
        cols: 6,
    },
    // {
    //     type: "v-select",
    //     margin: true,
    //     showLabel: true,
    //     label: "Area",
    //     labelName: "name",
    //     options: [],
    //     model: null,
    //     cols: 12,
    //     reduce: "id",
    // },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Payment Method",
        labelName: "name",
        options: [
            { name: app.$i18n.t("Fortnightly"), id: 1 },
            { name: app.$i18n.t("Monthly"), id: 2 },
        ],
        model: null,
        cols: 6,
    },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Pago Adicional",
        labelName: "name",
        options: [
            { name: "SI", id: 1 },
            { name: "NO", id: 0 },
        ],
        model: null,
        cols: 6,
    },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Contrato",
        labelName: "name",
        options: [
            { name: "R x H", id: 'R x H' },
            { name: "Planilla", id: 'Planilla' },
        ],
        model: null,
        cols: 6,
    },
];